import { cartApproverMessageStyles } from "@insite/content-library/Widgets/Common/CartApproverMessage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(cartApproverMessageStyles, {
    approvingText: {
        css: css`
            width: 100%;
            font-size: ${TYPOGRAPHY.size.smaller};
            color: ${COLORS.white};
        `,
    },
    approvingWrapper: {
        css: css`
            text-align: center;
            padding: 10px;
            background-color: #3d3d3d;
            margin-bottom: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-left: 15px !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
});
